export const M2M_ROLLER_BLINDS_MIN_WIDTH = "41";
export const M2M_ROLLER_BLINDS_MIN_HEIGHT = "40";
export const M2M_ROLLER_BLINDS_MAKING_COST = "32.00";
export const M2M_ROLLER_BLINDS_MAKING_COST_MIN_WIDTH = "70";
export const M2M_ROMAN_BLINDS_MIN_WIDTH = "42";
export const M2M_ROMAN_BLINDS_MIN_HEIGHT = "50";
export const M2M_ROMAN_BLINDS_MIN_INSTALLATION_HEIGHT = "180";
export const M2M_CURTAINS_MIN_HEIGHT = "50";
export const M2M_CURTAINS_MIN_WIDTH = "30";
export const M2M_MEDIA_BASE_URL =
  "https://media.johnlewiscontent.com/i/JohnLewis/";
export const M2M_CURTAINS_DEFAULT_EYELET_COLOUR = "Stainless Steel";

export const PRICE_TECHNICAL_ERROR_HEADING =
  "Sorry, we are experiencing technical problems with the made-to-measure product(s).";
export const PRICE_TECHNICAL_ERROR_BODY =
  "Please note your measurements and try again later";

export const PRICE_GENERAL_ERROR_HEADING =
  "Your made-to-measure product(s) is currently unavailable via the website.";
export const PRICE_GENERAL_ERROR_BODY =
  'Try a different fabric or note your measurements and <a href="/our-shops">visit a John Lewis shop</a> for assistance';

export const PRICE_WIDTH_EXCEEDS_MAXIMUM_ERROR_HEADING =
  "Sorry, your measurement exceeds the maximum width of {0}cm available for this fabric.";
export const PRICE_DROP_EXCEEDS_MAXIMUM_ERROR_HEADING =
  "Sorry, your measurement exceeds the maximum drop of {0}cm available for this fabric.";
export const PRICE_HEIGHT_EXCEEDS_MAXIMUM_ERROR_HEADING =
  "Sorry, your measurement exceeds the maximum height available for this fabric.";
export const PRICE_EXCEEDS_MAXIMUM_ERROR_BODY =
  'You may require our in-store bespoke service, please take your measurements to your local <a href="/our-shops">John Lewis & Partners shop</a>.';

export const PRICE_REQUIRES_JOINS_ERROR_HEADING =
  "The fabric you have selected requires joins at this size (when fabric is joined together to create a larger blind).";
export const PRICE_REQUIRES_JOINS_ERROR_BODY =
  'Try a different fabric or note your measurements and visit your local <a href="/our-shops">John Lewis & Partners shop</a> for assistance.';

export const PRICE_TOO_HEAVY_FABRIC_ERROR_HEADING =
  "The chosen blind combination at this size is too heavy for the control mechanism.";
export const PRICE_TOO_HEAVY_FABRIC_ERROR_BODY =
  "Please try a different fabric";

export const ROMAN_BLINDS_DESCRIPTION = [
  `Select a stacking style, select a window fitting, choose your control options, add your measurements and choose your lining options. Herbert Parkinson, our exclusive manufacturer in Lancashire, will create your blinds and send them within 7-14 working days.`,
  `Blind cords and chains can present a safety risk for children and pets. We advise you to read and understand the information in the child safety hub before placing your order.`,
];

export const CURTAINS_DESCRIPTION = `Pick a heading style, add your measurements and choose your lining options. Herbert Parkinson, our exclusive manufacturer in Lancashire, will create your curtains and send them within 7-14 working days.`;
